import { render, staticRenderFns } from "./LiveSetupForm.vue?vue&type=template&id=5243074d"
import script from "./LiveSetupForm.vue?vue&type=script&lang=js"
export * from "./LiveSetupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports